import React, { Component } from 'react'
import PT from 'prop-types'
import Post from './Post'
import { imagesProp } from '../../propTypes'
import './PostsMobile.css'

class PostsMobile extends Component {
  state = { width: 0 }

  componentDidMount() {
    this.setSize()
    window.addEventListener('resize', this.setSize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setSize)
  }

  setSize = () => {
    this.setState({ width: this.ref.clientWidth })
  }

  getRef = (ref) => {
    this.ref = ref
  }

  render() {
    return (
      <div className="posts-mobile" ref={this.getRef}>
        {this.props.posts.map(post => (
          <Post
            key={post._id}
            colWidth={this.state.width}
            {...post}
          />
        ))}
      </div>
    )
  }
}

PostsMobile.propTypes = {
  posts: PT.arrayOf(PT.shape({
    _id: PT.string.isRequired,
    title: PT.string.isRequired,
    shortText: PT.string.isRequired,
    images: imagesProp,
  })).isRequired,
}

export default PostsMobile



// WEBPACK FOOTER //
// ./src/components/Post/PostsMobile.js